"use strict";
exports.__esModule = true;
var assert_1 = require("./assert");
var ImageBoss = /** @class */ (function () {
    function ImageBoss() {
    }
    /**
     * Converts your image path to an url that uses Imageboss' services
     * @param imagePath
     * @param params
     * @example
     * const url = ImageBoss.getURL(
        '/test.img',
        { operation: 'cdn', options: 'sharpen:4' },
      );
     */
    ImageBoss.getURL = function (imagePath, params) {
        if (!params.operation) {
            throw new Error('please set an operation to perform');
        }
        var source = params.source || ImageBoss.source;
        // get a clean url
        var url = "https://img.imageboss.me/" + source + "/" + params.operation;
        var shouldHaveFilters = params.operation !== 'cdn';
        // Process the operation
        if (params.operation.startsWith('cover')) {
            assert_1["default"](params.width && params.height, 'cover operation requires width and height');
            url = url + "/" + params.width + "x" + params.height;
        }
        else if (params.operation === 'width') {
            assert_1["default"](params.width, 'width operation requires the width as a parameter');
            url = url + "/" + params.width;
        }
        else if (params.operation === 'height') {
            assert_1["default"](params.height, 'height operation requires the height as a parameter');
            url = url + "/" + params.height;
        }
        // Add filters
        if (shouldHaveFilters && params.options) {
            url = url + "/" + params.options;
        }
        return "" + url + imagePath;
    };
    return ImageBoss;
}());
exports.ImageBoss = ImageBoss;
